import React, {createContext, useState, useEffect} from "react";

//create a context object

export const SiteStateContext = createContext();

//create the provider
export const SiteStateProvider = ({children}) => 
    { //shared status
        const [status, setStatus] = useState
        (
            () => 
            {
                return localStorage.getItem("userStatus") || "All";
            }
        );

        useEffect
        (
            () => 
            {
                //keeps local storage synced on change
                localStorage.setItem("userStatus", status);

            }, [status]
        );

        // values this shares with other stuff, so status and setStatus rn
        const value = 
        {
            status, setStatus

        };

        return(
            <SiteStateContext.Provider value={value}> {children}</SiteStateContext.Provider>

        );
    };

